module.exports = __webpack_public_path__ + "img/smart-interview.eb613709.png";